import { Route, Routes as ReactRouterRoutes, useNavigate, useLocation } from 'react-router'
import React, { useCallback } from 'react'
import { Create, Landing, ManagePage, PageTracker } from './pages'
import { LANDING_ROUTE, CREATE_ROUTE, MANAGE_ROUTE } from './utils/routes'
import { isInIframe } from './utils'

export const Routes = () => {
	const navigate = useNavigate()
	const location = useLocation()


	// This will sync the URL between the iframe and the parent window
	const onMessage = useCallback( ( event: MessageEvent ) => {
		if ( event.data.type === 'url-sync' ) {
			const url = new URL( event.data.url )
			const fullPath = url.hash.substring( 1 ) // Remove the # from hash
			const integrationsPart = fullPath.split( '/integrations/' )[ 1 ]

			const pathname = integrationsPart ? `/${integrationsPart}` : '/'

			if ( pathname !== location.pathname ) {
				navigate( pathname )
			}
		}
	}, [ location.pathname, navigate ] )

	React.useEffect( () => {
		window.parent.postMessage( { type: 'url-sync', url: location.pathname }, '*' )
	}, [ location.pathname ] )

	React.useEffect( () => {
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		if ( isInIframe() ) {
			window.addEventListener( 'message', onMessage )
			window.parent.postMessage( { type: 'loaded' }, '*' )
			return () => window.removeEventListener( 'message', onMessage )
		}
		return () => undefined
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [] )

	return (
		<ReactRouterRoutes>
			<Route element={<PageTracker />}>
				<Route path={LANDING_ROUTE} element={<Landing />} />
				<Route path={CREATE_ROUTE} element={<Create />} />
				<Route path={MANAGE_ROUTE} element={<ManagePage />} />
			</Route>
		</ReactRouterRoutes>
	)
}
